import Proptypes from 'prop-types';
import React from 'react';

import { Container } from './styledComponents';

import SpinnerIcon from '../../../assets/icons/new-loader.svg';
import SpinnerIconDgrey from '../../../assets/icons/new-loader-dgrey.svg';

const SPINNER_ICON = {
  DEFAULT: SpinnerIcon,
  DGREY: SpinnerIconDgrey,
};

export const SPINNER_COLOR = {
  DEFAULT: 'DEFAULT',
  DGREY: 'DGREY',
};

const ComponentLoader = (props) => {
  const { width, height, color } = props;
  return (
    <Container>
      <img
        alt={'component-loader'}
        height={`${height}px`}
        src={SPINNER_ICON[color] || SPINNER_ICON.DEFAULT}
        width={`${width}px`}
      />
    </Container>
  );
};

ComponentLoader.propTypes = {
  width: Proptypes.number,
  height: Proptypes.number,
  color: Proptypes.oneOf(Object.values(SPINNER_COLOR)),
};

ComponentLoader.defaultProps = {
  width: 40,
  height: 40,
  color: SPINNER_COLOR.DEFAULT,
};

export default ComponentLoader;
